import ForumApp from 'mk2/apps/forum/ForumApp';
import rootSagas from 'mk2/apps/forum/sagas';
import { appInit } from 'mk2/helpers/init';
import { routes } from 'mk2/router';

appInit(
    ForumApp,
    routes,
    rootSagas,
).then((rerender) => {
    if (module.hot) {
        module.hot.accept(['mk2/apps/forum/ForumApp', 'mk2/router'], () => {
            const NextApp = require('mk2/apps/forum/ForumApp').default;
            rerender(NextApp);
        });
    }
});
